import React, {useEffect, useState} from 'react';
import { useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import STAFF_3 from '../../Work-Assets/WhatsApp Image 2025-01-11 at 10.01.18.jpeg';
import '../../Work-css/Marketing_space.css';
import Other from '../Let/Others';
import Internship from '../Let/Internship';
import Doc_quiz from './Agencies/Doc_quiz';
import Jobs from '../Let/Job_Application/Jobs';
import Other_part from './Others';
import { v4 as uuidv4 } from 'uuid';


function Marketing_space({ms}) {
    const [helb, setHelb] = useState(false)
    const [scholarship, setScholarship] = useState(false)
    const [other, setOthers] = useState(false)
    const [marketcapital, setMarketcapital] = useState(true)
    const [internship, setInternship] = useState(false)
    const [jobs, setJobs] = useState(false)
    const [cs, setCs] = useState(false)
    const [type, setType] = useState('')
    const [intern, setIntern] = useState('')
    const [uniq, setUnique] = useState(uuidv4())
    
    const close = () =>
    {
        ms(false)
    }

    const Helb = () =>
    {
        setCs(true)  
        setMarketcapital(false)  
        setInternship(false)
        setJobs(false)
    }

    const Scholarship = () =>
    {
        setCs(true)  
        setMarketcapital(false)
        setInternship(false)
        setJobs(false)
    }

    const internships = () =>
    {
       
        setJobs(true)
        setInternship(false)
       setOthers(false)
       setMarketcapital(false)
       setType('intern')
      
    }
            
    const Others = () =>
    {
        setOthers(true)  
        setMarketcapital(false)
    }

    const job_btn = () =>{
        setJobs(true)
        setInternship(false)
       setOthers(false)
       setMarketcapital(false)
       setType('job')
    }

    const attachment = () =>{
        setJobs(true)
        setInternship(false)
       setOthers(false)
       setMarketcapital(false)
       setType('attachment') 
    }
  return ( 
    <div className="whole_AU">
        <div className='close_tab' onClick={close}><FontAwesomeIcon icon={faArrowLeft} /></div>
        <div className='marketing_buttons'>
            
            <button onClick={attachment}>Attachment Opportunities</button>
            <button onClick={internships}>Internship Opportunities</button>
            {/** change from here */}
            <button onClick={Helb}>Helb Updates and Links</button>
            <button onClick={Scholarship}>Scholarship Links</button>
            <button onClick={Others}>Others</button>
            <button onClick={job_btn}>Job Opportunities</button>
        </div>

        {marketcapital?(<div className='market_capital'>
<div className='marketing_DIv'>
<div className='marketing_IMG'><img src={STAFF_3} /></div>
<p className='marketing_Words'>
Welcome to Hostel Adventures – Where Comfort Meets Adventure

Nestled in the heart of a vibrant community, our hostel offers more than just a place to stay – it’s the perfect blend of comfort and adventure. 
Imagine waking up to clear blue skies, surrounded by a modern and welcoming space designed to inspire exploration. 
Whether you’re here for a short stay or an extended journey, we provide a unique experience that goes beyond the ordinary
</p>
</div>
</div>):('')}



{other?(<div className='other'><Other /></div>):('')}
{internship?(<div className='other'><Internship ms={ms} type={type} uniq={uniq} /></div>):('')}
{jobs?(<div className='other'><Jobs ms={ms} type={type} uniq={uniq} /></div>):('')}
{cs?(<div className='other'><Other_part ms={ms} /></div>):('')}

    </div>
  )
}

export default Marketing_space